import React, { useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { Cpu } from "lucide-react";
import { PageHeader } from "../../../components/PageHeader";
import KeyStatusTab from "./KeyStatusTab";
import MediaModelsTab from "./MediaModelsTab";
import BudgetTab from "./BudgetTab";
import AlertsTab from "./AlertsTab";
import RealtimeAvatarTab from "./RealtimeAvatarTab";
import SupportBillingTab from "./SupportBillingTab";

const TABS = [["keys", "Ringkasan & Key"], ["models", "Model Media"], ["budget", "Anggaran & Biaya"], ["realtime", "Realtime Avatar"], ["support", "Support Billing"], ["alerts", "Peringatan"]];

export default function PlatformLlm() {
  const { llmAlerts = 0, refreshLlmAlerts } = useOutletContext() || {};
  const [params] = useSearchParams();
  const [tab, setTab] = useState(() => (TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "keys"));
  return (
    <div data-testid="llm-page">
      <PageHeader icon={Cpu} title="Model AI" description="Sumber key provider, katalog model gambar & video, anggaran bulanan, dan peringatan kuota." />
      <div className="tabs mt-5">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`llm-tab-${k}`} className={`tab ${tab === k ? "tab-active" : ""}`}>
            {l}{k === "alerts" && llmAlerts > 0 && <span className="ml-1.5 rounded-full bg-rose-500 px-1.5 py-0.5 text-[10px] font-bold text-white" data-testid="llm-tab-alerts-count">{llmAlerts}</span>}
          </button>
        ))}
      </div>
      <div className="mt-6">
        {tab === "keys" && <KeyStatusTab />}
        {tab === "models" && <MediaModelsTab />}
        {tab === "budget" && <BudgetTab />}
        {tab === "realtime" && <RealtimeAvatarTab />}
        {tab === "support" && <SupportBillingTab />}
        {tab === "alerts" && <AlertsTab onChange={refreshLlmAlerts} />}
      </div>
    </div>
  );
}
